import { Model } from 'vue-mc'
import axiosConfig from './Config'

export default class extends Model {
	public getRequest(config: any) {
		axiosConfig(config)
		return super.getRequest(config)
	}
}
